import { Backdrop, Button, CircularProgress, Grid, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { Box } from "@mui/system";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import * as Yup from "yup";
import Error from "../../../../components/error/error";
import { cfpBaseUrl } from "../../../../network/urls";
import "./CreatePermission.scss";
import { AllPermissions } from "../../../../network/APIs/APIs";

const initialValues = {
  iv_name: "",
  iv_group_name: "",
};

const treeStyle = {
  fontFamily: "Arial, sans-serif",
  border: "1px solid black",
  padding: "10px",
  background: "gray",
};

const treeNodeStyle = {
  display: "flex",
  alignItems: "center",
  margin: "5px 0",
  backgroundColor: "#fff",
  padding: "8px",
  borderRadius: "4px",
};

const treeIconStyle = {
  fontSize: "18px",
  marginRight: "5px",
  cursor: "pointer",
};

const radioStyle = {
  marginRight: "10px",
};

function TreeNode({
  item,
  data,
  selectedItemId,
  handleSelect,
  expandedNodes,
  setExpandedNodes,
}) {
  const hasChildren = data.some((child) => child.parent_idt === item.idt);
  const isExpanded = expandedNodes.includes(item.idt);

  const handleToggle = () => {
    if (isExpanded) {
      setExpandedNodes(expandedNodes.filter((id) => id !== item.idt));
    } else {
      setExpandedNodes([...expandedNodes, item.idt]);
    }
  };

  return (
    <div style={treeNodeStyle}>
      {hasChildren > 0 && (
        <div style={treeIconStyle} onClick={handleToggle}>
          {isExpanded ? "▼" : "▶"}
        </div>
      )}
      <input
        type="radio"
        name="selectedItem"
        style={radioStyle}
        checked={selectedItemId === item.idt}
        onChange={() => handleSelect(item.idt)}
        value={item.idt}
      />
      <label>{item.name}</label>
      {isExpanded && hasChildren && (
        <div style={{ marginLeft: "25px" }}>
          {data
            .filter((child) => child.parent_idt === item.idt)
            .map((child) => (
              <TreeNode
                key={child.idt}
                item={child}
                data={data}
                selectedItemId={selectedItemId}
                handleSelect={handleSelect}
                expandedNodes={expandedNodes}
                setExpandedNodes={setExpandedNodes}
              />
            ))}
        </div>
      )}
    </div>
  );
}

function TreeViewWithRadioSingleSelect({ data, nodeValue }) {
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState([]);

  const handleSelect = (itemId) => {
    setSelectedItemId(itemId);
    nodeValue(itemId);
  };

  return (
    <div style={treeStyle}>
      {data
        .filter((item) => item.parent_idt === null)
        .map((item) => (
          <TreeNode
            key={item.idt}
            item={item}
            data={data}
            selectedItemId={selectedItemId}
            handleSelect={handleSelect}
            expandedNodes={expandedNodes}
            setExpandedNodes={setExpandedNodes}
          />
        ))}
    </div>
  );
}

const CreatePermission = () => {
  const [idt, setIdt] = useState(); 
  const [status, setStatus] = useState(1);
  const { token, userId, permissions } = useSelector((state) => state.auth)
  const [error, setError] = useState(false);
  const [sortedPermissions, setSortedPermissions] = useState([])
  const [allPermissions, setAllPermissions] = useState([])
  const [viewBackdrop, setViewBackdrop] = React.useState(false);

  const errorCloses = () => {
    setError('')
  }

  const nodeValue = (value) => {
    setIdt(value);
  };

  const location = useLocation();
  useEffect(() => {
    const getAllPermissions = async () => {
      setViewBackdrop(true)
      let { allPermissions, sortedAllPermissions } = await AllPermissions(token, permissions)
      setSortedPermissions(sortedAllPermissions)
      setAllPermissions(allPermissions)
      setViewBackdrop(false)
    }
    getAllPermissions()
  }, [])

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: Yup.object({
        iv_name: Yup.string().required("Enter name for permission."),
        iv_group_name: Yup.string().required(
          "Enter group name for permission."
        ),
      }),
      onSubmit: async (values, { resetForm }) => {

        var formdata = new FormData();
        if (idt !== undefined) {
          formdata.append("idt", idt);
        }
        formdata.append("name", values.iv_name);
        formdata.append("groupName", values.iv_group_name);
        formdata.append("status", status);
        formdata.append("createdBy", userId);

        const myHeaders = new Headers();
        myHeaders.append('Authorization', token);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders, 
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "role/addPrem", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              resetForm();
              // Navigate("/permission-management")
            } else {
              setError(result.message);
            }
          })
          .catch((error) => {
            setError(error);
          });
      },
    });
  return (
    <>
      <Grid container spacing={2} className="new">
        <Grid item xs={12}>
          <h3>Add permission :</h3>
        </Grid>
        <Grid item xs={4}>
          <label htmlFor="Name">Name</label>
          <TextField
            type="text"
            autoComplete="off"
            onChange={handleChange}
            name="iv_name"
            value={values.iv_name}
            onBlur={handleBlur}
            fullWidth
          />
          <Box className="from-Error">
            {errors.iv_name && touched.iv_name ? errors.iv_name : null}
          </Box>
        </Grid>
        <Grid item xs={4}>
          <label htmlFor="Group">Group</label>
          <TextField
            type="text"
            autoComplete="off"
            onChange={handleChange}
            name="iv_group_name"
            value={values.iv_group_name}
            onBlur={handleBlur}
            fullWidth
          />
          <Box className="from-Error">
            {errors.iv_group_name && touched.iv_group_name
              ? errors.iv_group_name
              : null}
          </Box>
        </Grid>
        <Grid item xs={2} style={{ display: "flex", flexDirection: "column" }}>
          <label>Status</label>
          <FormControl className="form-control">
            <RadioGroup
              className="radio-group"
              row
              name="iv_applicant_status"
              defaultValue={status}
              value={status}
              onChange={() => {
                if (status === 1) {
                  setStatus(0);
                } else {
                  setStatus(1);
                }
              }}
            >
              <FormControlLabel
                value={1}
                className="form-control-label"
                control={<Radio />}
                label="Active"
                name="Active"
                labelPlacement="end"
              />
              <FormControlLabel
                value={0}
                className="form-control-label"
                control={<Radio />}
                label="Inactive"
                name="Inactive"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TreeViewWithRadioSingleSelect data={allPermissions} nodeValue={nodeValue} />
        </Grid>
        {
          error &&
          <Error
            error={error}
            onClose={() => errorCloses()}
            backgroundColor="#FFC0CB"
            textColor="#bb0303"
            iconColor="#bb0303"
          />
        }
        <Button
          variant="contained"
          size="small"
          color="success"
          style={{
            backgroundColor: "blue",
            alignItems: "center",
            marginLeft: "45rem",
            marginTop: "10px",
            padding: "10px 30px",
          }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Grid>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >    </>
  );
};

export default CreatePermission;
